import { Injectable } from '@angular/core';
import { BaseService } from '../base/base.service';
import { filter, map, tap } from 'rxjs/operators';
import { ServerEventService } from '../server-event.service';
import { DrEvent } from '@app/shared/models/server-event.model';

type SessionExpirationPayload = {
    accessToken: string;
    user: string;
    platform: string;
};

export interface SessionExpirationEventData
    extends DrEvent<SessionExpirationPayload | string, any> {}

@Injectable({
    providedIn: 'root'
})
export class SessionExpirationWebSocketService extends BaseService {

    public static WebSocketEvents = {
        USER_SESSION_EXPIRED: 'user.session-expired'
    };

    private readonly msgPrefix = 'SessionExpirationWebSocketService';

    constructor(private _serverEventService: ServerEventService<SessionExpirationPayload>) {
        super();
    }

    get socket() {
        return this._serverEventService.events.pipe(
            filter(
                (event) =>
                    event.event ===
                    SessionExpirationWebSocketService.WebSocketEvents
                        .USER_SESSION_EXPIRED
            ),
            tap((event) => console.log(`${this.msgPrefix} - processing event: ${event.event}`)),
            map((event) => event)
        );
    }
}
